module.exports = __webpack_public_path__ + "img/hr-heated-t-right-1.80a87d62.png";